export   const facalityes = [
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/53790514_10155706394201627_6078190979465084928_n.jpg?_nc_cat=101&_nc_ht=scontent.fisb5-1.fna&oh=b31b7002092a82ec8dd4c011830a8c92&oe=5D52E459",
        alt:"full stack developer",
        name:"Sir Syed Murtza(Founder of Digital Cru)",
        role:"Full Stack Developer",
        description:"Full stack web developer,learn from code,code is not tough,if you play with it the you will be a master after few time later",
    },
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/26230193_760939547428625_6468586919139455436_n.jpg?_nc_cat=111&_nc_ht=scontent.fisb5-1.fna&oh=08a9b835ba7d3c708ec34cac005e282a&oe=5D93863B",
        alt:"developer",
        name:"sir Mohsin Naqvi",
        role:"Full Stack Islamic Researcher",
        description:"he help  him to understand the religions problems and help Kashif to understand the different Research from Enjeel and Quran",
    },
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/56673004_2820052204886660_8463151332130291712_n.jpg?_nc_cat=111&_nc_ht=scontent.fisb5-1.fna&oh=4b3e7c552ee64ebcc2b3dcbf63b9a952&oe=5D99A056",
        alt:"developer",
        name:"Sadaif",
        role:"Front end Developer",
        description:"Front end web developer,learn from code ",
    },
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/30713245_2377131572313138_6182121276732528908_n.jpg?_nc_cat=105&_nc_ht=scontent.fisb5-1.fna&oh=831a9996ecb02afd21f16bb59bff8523&oe=5D957C21",
        alt:"developer",
        name:"Hizqeel",
        role:"Back-end Developer",
        description:"Back end web developer,learn from code ",
    },
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/46675547_2033831646709914_3255663971478274048_n.jpg?_nc_cat=102&_nc_ht=scontent.fisb5-1.fna&oh=9840f809180d36ab452da59c1afbb042&oe=5D590268",
        alt:"developer",
        name:"Muzamil",
        role:"Back-end Developer",
        description:"back end web developer,learn from code ",
    },
    {
        url:"https://scontent.fisb5-1.fna.fbcdn.net/v/t1.0-9/15940528_373004099728938_7550667385047692076_n.jpg?_nc_cat=101&_nc_ht=scontent.fisb5-1.fna&oh=967f4db8398035488ef2133408474ce0&oe=5D9D9D9A",
        alt:"developer",
        name:"Kashif",
        role:"front end developer",
        description:"Front end web developer,learn from code.i think that code is not too much tough,learn as a begineer level,Because every master was the begineer first",
    },
    
]